/**
 * 余额管理
 */
<template>
  <div class="invoice-detail-page">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/payCenter/billingRecordList' }"
        >开票记录</el-breadcrumb-item
      >
      <el-breadcrumb-item>开票详情</el-breadcrumb-item>
    </el-breadcrumb>
    <!--账单列表-->
    <div class="detail-card">
      <div class="detail-card__header">开票明细</div>
      <div class="detail-card__body">
        <div class="detail-grid">
          <div
            class="detail-col"
            v-for="(col, colIndex) in invoiceDetailColumns"
            :key="colIndex"
          >
            <div
              class="detail-item"
              v-for="item in col"
              :key="item.label"
            >
              <span class="detail-label">{{ item.label }}</span>
              <span
                class="detail-value"
                :class="{ 'is-amount': item.emphasize }"
                :title="item.value"
                >{{ item.value }}</span
              >
            </div>
          </div>
        </div>
        <el-table
          size="small"
          :data="detail_table1"
          highlight-current-row
          v-loading="loading"
          element-loading-text="拼命加载中"
          empty-text="暂无数据"
          style="width: 100%"
        >
          <el-table-column
            prop="rechargeId"
            label="充值id"
            min-width="200"
          >
          </el-table-column>
          <el-table-column prop="arrivalTime" label="充值时间" min-width="200">
          </el-table-column>
          <el-table-column
            prop="rechargeAmount"
            label="充值金额"
            min-width="200"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.rechargeAmount.toFixed(2) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="invoiceAmount"
            label="开票金额"
            min-width="200"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.invoiceAmount.toFixed(2) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="voidedAmount" label="作废金额" min-width="300">
            <template slot-scope="scope">
              <span>{{ scope.row.voidedAmount.toFixed(2) }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="detail-card">
      <div class="detail-card__header">关联任务</div>
      <div class="detail-card__body">
        <el-table
          size="small"
          :data="detail_table2"
          highlight-current-row
          v-loading="loading"
          element-loading-text="拼命加载中"
          empty-text="暂无数据"
          style="width: 100%"
        >
          <el-table-column
            prop="taskName"
            label="任务名称"
            min-width="200"
          >
          </el-table-column>
          <el-table-column prop="taskType" label="任务类型" min-width="200">
          </el-table-column>

          <el-table-column prop="" label="任务描述" min-width="300">
            <template slot-scope="scope">
              <el-popover placement="top-start" width="200" trigger="hover">
                <span>【服务内容】{{ scope.row.content }}</span
                ><br />
                <span>【计费模式】{{ scope.row.billMode }}</span
                ><br />
                <span>【服务时间】{{ scope.row.serviceTime }}</span>

                <span class="btnNoBorderBlue" slot="reference">查看</span>
              </el-popover>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="detail-card">
      <div class="detail-card__header">发票开具详情</div>
      <div class="detail-card__body">
        <el-table
          size="small"
          :data="detail_table3"
          highlight-current-row
          v-loading="loading"
          element-loading-text="拼命加载中"
          empty-text="暂无数据"
          style="width: 100%"
        >
          <!-- <el-table-column
            fixed
            prop="invoiceCode"
            label="发票代码"
            min-width="200"
          >
          </el-table-column>
          <el-table-column
            prop="invoiceNumber"
            label="发票票号"
            min-width="200"
          >
          </el-table-column> -->
          <el-table-column prop="invoiceDate" label="开票日期">
          </el-table-column>
          <!-- <el-table-column
            prop="netAmount"
            label="开具金额(不含税)"
            min-width="200"
          >
            <template slot-scope="scope">
              <span v-if="shouldDisplayNetAmount(scope.row.netAmount)">
                {{ scope.row.netAmount.toFixed(2) }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="totalAmount"
            label="价税合计(小写)"
            min-width="200"
          >
            <template slot-scope="scope">
              <span v-if="shouldDisplayNetAmount(scope.row.totalAmount)">
                {{ scope.row.totalAmount.toFixed(2) }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="totalAmountCh"
            label="价税合计(大写)"
            min-width="200"
          >
          </el-table-column> -->
          <el-table-column prop="invoiceStyle" label="发票样式">
          </el-table-column>
          <el-table-column prop="" label="发票">
            <template slot-scope="scope">
              <span
                class="btnNoBorderBlue"
                @click="opendetails(scope.row.invoiceDownloadUrl)"
                >查看</span
              >
            </template>
          </el-table-column>

          <!-- <el-table-column
            prop="invoiceStatus"
            label="发票状态"
            :cell-style="getStatusStyle"
          >
          </el-table-column> -->

          <el-table-column label="发票状态">
            <template slot-scope="scope">
              <span :style="getStatusStyle(scope.row.invoiceStatus)">
                {{ scope.row.invoiceStatus }}
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!--充值打款信息-->
    <div class="detail-card">
      <div class="detail-card__header">物流信息</div>
      <div class="detail-card__body">
        <div class="detail-grid detail-grid--logistics">
          <div
            class="detail-item"
            v-for="item in logisticsFields"
            :key="item.label"
          >
            <span class="detail-label">{{ item.label }}</span>
            <span class="detail-value" :title="item.value">{{ item.value }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 编辑界面 -->
    <el-dialog
      :title="title"
      :visible.sync="editFormVisible"
      width="30%"
      @click="closeDialog"
    >
      <el-form
        label-width="120px"
        :model="editForm"
        :rules="rules"
        ref="editForm"
      >
        <el-form-item label="部门名称" prop="deptName">
          <el-input
            size="small"
            v-model="editForm.deptName"
            auto-complete="off"
            placeholder="请输入部门名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="部门代码" prop="deptNo">
          <el-input
            size="small"
            v-model="editForm.deptNo"
            auto-complete="off"
            placeholder="请输入部门代码"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="submitForm('editForm')"
          >保存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  receiptInfo,
  billsList,
  billexcel,
  invoicedetails,
} from "../../api/userMG";
import Pagination from "../../components/Pagination";
export default {
  data() {
    return {
      detail_table1: [],
      detail_table2: [],
      detail_table3: [],
      info: {},
      status_list: [
        {
          label: "加款",
          value: 1,
        },
        {
          label: "扣款",
          value: 2,
        },
        {
          label: "退款",
          value: 3,
        },
        {
          label: "退票",
          value: 4,
        },
        {
          label: "垫付资金",
          value: 5,
        },
        {
          label: "垫资还款",
          value: 6,
        },
        {
          label: "原路退款",
          value: 7,
        },
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: "添加",
      editForm: {
        date: [],
        positionId: "",
        positionName: "",
        positionState: "",
      },
      // rules表单验证
      rules: {},
      formInline: {
        page: 1,
        pageSize: 10,
        varLable: "",
        varName: "",
        token: localStorage.getItem("logintoken"),
        operationType: 1,
        date: [],
        startDate: "",
        endDate: "",
      },
      balance: JSON.parse(localStorage.getItem("user_info")).balance,
      name: JSON.parse(localStorage.getItem("user_info")).createUserId,
      // 删除部门
      seletedata: {
        ids: "",
        token: localStorage.getItem("logintoken"),
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        page: 1,
        pageSize: 10,
        total: 10,
      },
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getinvoicedetails(this.$route.query.id);
  },
  computed: {
    invoiceDetailColumns() {
      const info = this.info || {};
      return [
        [
          { label: "公司名称", value: this.displayText(info.companyName) },
          { label: "税务登记号", value: this.displayText(info.taxNumber) },
          {
            label: "开户行帐号",
            value: this.displayText(info.depositBankAccount),
          },
          { label: "开户行", value: this.displayText(info.depositBank) },
          { label: "发送至邮箱", value: this.displayText(info.sendToMail) },
        ],
        [
          { label: "地址", value: this.displayText(info.address) },
          { label: "电话", value: this.displayText(info.phone) },
          { label: "发票类型", value: this.displayText(info.invoiceType) },
          { label: "开票类目", value: this.displayText(info.invoiceCategory) },
        ],
        [
          {
            label: "开票金额",
            value: this.displayText(info.invoiceAmount),
            emphasize: true,
          },
          { label: "备注", value: this.displayText(info.remark) },
          { label: "开票状态", value: this.displayText(info.recordStatus) },
          {
            label: "电子发票格式",
            value: this.displayText(info.electronicInvoiceFormat),
          },
        ],
      ];
    },
    logisticsFields() {
      const info = this.info || {};
      const mailing =
        info.mailingAddress && info.mailingAddress.detail
          ? info.mailingAddress.detail
          : "";
      return [
        { label: "物流单号", value: this.displayText(info.trackingNumber) },
        { label: "寄件时间", value: this.displayText(info.dispatchAt) },
        { label: "邮寄地址", value: this.displayText(mailing) },
        { label: "当前物流状态", value: this.displayText(info.deliveryStatus) },
      ];
    },
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    displayText(value) {
      if (value === 0 || value === 0.0) return "0";
      if (value === null || value === undefined || value === "") return "-";
      return value;
    },
    shouldDisplayNetAmount(netAmount) {
      // 检查 netAmount 是否为 0.00、0、null 或空字符串
      return (
        netAmount !== 0 &&
        netAmount !== 0.0 &&
        netAmount !== null &&
        netAmount !== ""
      );
    },
    opendetails(url) {
      if (!url) {
        this.$message.error("发票正在生成上传中，请稍后重试");
        return;
      }
      window.open(url);
    },
    exportdata() {
      billexcel().then((res) => {
        if (res.msg == "success") {
          window.open(res.data.downloadUrl);
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },
    getinvoicedetails(id) {
      invoicedetails(id)
        .then((res) => {
          if (res.msg != "success") {
            this.$message({
              type: "error",
              message: res.msg,
            });
          } else {
            this.info = res.data;
            this.detail_table1 = res.data.linkedRechargeRecordsList;
            // let obj1 = {
            //   rechargeId: res.data.rechargeId,
            //   arrivalTime: res.data.arrivalTime,
            //   rechargeAmount: res.data.rechargeAmount,
            //   invoiceAmount: res.data.invoiceAmount,
            // }
            // this.detail_table1.push(obj1)

            this.detail_table2 = res.data.linkedTasksList;
            // let obj2 = {
            //   taskName: res.data.taskName,
            //   taskType: res.data.taskType,
            // }
            // this.detail_table2.push(obj2)

            this.detail_table3 = res.data.invoiceDetailList;
            // let obj3 = {
            //   invoiceCode: res.data.invoiceCode,
            //   invoiceNumber: res.data.invoiceNumber,
            //   invoiceDate: res.data.invoiceDate,
            //   netAmount: res.data.netAmount,
            //   totalAmount: res.data.totalAmount,
            //   totalAmountCh: res.data.totalAmountCh,
            //   invoiceStyle: res.data.invoiceStyle,
            //   invoiceDownloadUrl: res.data.invoiceDownloadUrl,
            //   invoiceStatus: res.data.invoiceStatus,
            // };
            // this.detail_table3.push(obj3);
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },

    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate((valid) => {
        if (valid) {
          // deptSave(this.editForm)
          //   .then(res => {
          //     this.editFormVisible = false
          //     this.loading = false
          //     if (res.success) {
          //       this.getdata(this.formInline)
          //       this.$message({
          //         type: 'success',
          //         message: '公司保存成功！'
          //       })
          //     } else {
          //       this.$message({
          //         type: 'info',
          //         message: res.msg
          //       })
          //     }
          //   })
          //   .catch(err => {
          //     this.editFormVisible = false
          //     this.loading = false
          //     this.$message.error('公司保存失败，请稍后再试！')
          //   })
        } else {
          return false;
        }
      });
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // deptDelete(row.deptId)
          //   .then(res => {
          //     if (res.success) {
          //       this.$message({
          //         type: 'success',
          //         message: '公司已删除!'
          //       })
          //       this.getdata(this.formInline)
          //     } else {
          //       this.$message({
          //         type: 'info',
          //         message: res.msg
          //       })
          //     }
          //   })
          //   .catch(err => {
          //     this.loading = false
          //     this.$message.error('公司删除失败，请稍后再试！')
          //   })
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false;
    },
    getStatusStyle(status) {
      const colorMap = {
        红冲发票: "color: red; font-weight: bold",
        作废发票: "color: gray; text-decoration: line-through",
        正常发票: "color: green",
      };
      return colorMap[status] || ""; // 未知状态返回空样式
    },
  },
};
</script>

<style scoped>
.invoice-detail-page {
  padding-bottom: 8px;
}
.detail-card {
  margin-top: 16px;
  background: #fff;
}
.detail-card__header {
  height: 52px;
  padding: 0 24px;
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
  color: #272727;
  border-bottom: 1px solid #ebeef5;
}
.detail-card__body {
  padding: 20px 24px 24px;
}
.detail-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  column-gap: 32px;
  margin-bottom: 20px;
  padding-bottom: 4px;
  border-bottom: 1px solid #ebeef5;
}
.detail-grid--logistics {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom: none;
  row-gap: 14px;
}
.detail-col {
  min-width: 0;
}
.detail-item {
  display: flex;
  align-items: flex-start;
  min-width: 0;
  margin-bottom: 14px;
  font-size: 13px;
  line-height: 1.5;
}
.detail-col .detail-item:last-child {
  margin-bottom: 0;
}
.detail-label {
  flex-shrink: 0;
  width: 96px;
  color: #909399;
}
.detail-value {
  min-width: 0;
  color: #303133;
  word-break: break-all;
}
.detail-value.is-amount {
  color: #6255f2;
}
.btnNoBorderBlue {
  color: #1985ff;
  cursor: pointer;
}
@media (max-width: 1200px) {
  .detail-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    row-gap: 8px;
  }
}
</style>

 


// WEBPACK FOOTER //
// src/views/payCenter/invoiceDetail.vue